import gql from 'graphql-tag'

export const CREATE_CATEGORY = gql`
  mutation CreateCategory(
    $name: String!
    $description: String
    $remark: String
  ) {
    createCategory(
      data: { name: $name, description: $description, remark: $remark }
    ) {
      id
      name
    }
  }
`

export const UPDATE_CATEGORY = gql`
  mutation UpdateCategory(
    $id: Int!
    $name: String
    $description: String
    $remark: String
  ) {
    updateCategory(
      id: $id
      data: { name: $name, description: $description, remark: $remark }
    ) {
      id
      name
    }
  }
`

export const DELETE_CATEGORY = gql`
  mutation DeleteCategory($id: Int!) {
    deleteCategory(id: $id) {
      id
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/Category.js